import { useEffect, useState } from "react";
import { mailApi } from "./wappmail.service";
import { push } from "../navigation/v2/sales/push";

/**
 * El globito rojo de WappMail en el menú: los correos sin leer de Recibidos. Una sola consulta para toda la pestaña
 * (STATUS de INBOX, sin listar nada). Se actualiza al entrar, con el aviso al instante "correo" (wapp-push), cuando
 * WappMail marca algo leído/no leído, al volver a la pestaña y cada 2 minutos de respaldo.
 */
let valor = 0;
const oyentes = new Set<(n: number) => void>();
let espera: any = null;
let ultima = 0;

const poner = (n: number) => { valor = n; oyentes.forEach((f) => f(n)); };
const cargar = async () => {
	try { poner((await mailApi.noLeidos()).data.no_leidos || 0); ultima = Date.now(); } catch { /* sin servicio o sin buzón: se queda el número de antes */ }
};
const pedirEn = (ms: number) => { if (espera) return; espera = setTimeout(() => { espera = null; cargar(); }, ms); };

/** WappMail lo llama después de leer, marcar, mover o borrar. */
export const refrescarNoLeidosCorreo = () => pedirEn(400);

export const iniciarNoLeidosCorreo = (campusId: number): (() => void) => {
	const soltar = push.usar(campusId);
	const quitar = push.on("correo", () => pedirEn(800));
	// Al volver a la pestaña solo si lo último tiene más de 30 s (cambiar de pestaña es constante en el día).
	const alVolver = () => { if (document.visibilityState === "visible" && Date.now() - ultima > 30000) pedirEn(200); };
	document.addEventListener("visibilitychange", alVolver);
	const ciclo = setInterval(() => { if (document.visibilityState === "visible") cargar(); }, 120000);
	cargar();
	return () => { soltar(); quitar(); document.removeEventListener("visibilitychange", alVolver); clearInterval(ciclo); clearTimeout(espera); espera = null; poner(0); };
};

export const useNoLeidosCorreo = (): number => {
	const [n, setN] = useState(valor);
	useEffect(() => { oyentes.add(setN); setN(valor); return () => { oyentes.delete(setN); }; }, []);
	return n;
};
